import { render, staticRenderFns } from "./AffiliateView.vue?vue&type=template&id=b034ab2e&scoped=true&"
import script from "./AffiliateView.vue?vue&type=script&lang=js&"
export * from "./AffiliateView.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateView.vue?vue&type=style&index=0&id=b034ab2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b034ab2e",
  null
  
)

export default component.exports